import { useAppSelector } from '@/shared/infra/store/hooks';

/**
 * Hook to format document title by looking up the label from Redux store
 * If a matching document type is found, returns the label; otherwise returns formatted title
 * @param documentTitle - The document value to look up
 * @returns The label from Redux store, or formatted title as fallback
 */
export function useFormattedDocumentTitle(documentTitle: string | undefined | null): string {
  const customDocumentTypes = useAppSelector(
    (state) => state.customDocumentTypes.customDocumentTypes
  );

  if (!documentTitle) return '';

  // Find matching document type in Redux store by value
  const matchedDoc = customDocumentTypes.find(
    (doc) => doc.value === documentTitle
  );

  // Return label if found, otherwise format the title
  return matchedDoc?.label || documentTitle.replace(/_/g, ' ').toUpperCase();
}
